/*
 * @Description: 报价单有关语言包
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  新增报价单: 'New Quotation',
  列设置: 'Column Settings',
  查看: 'View',
  复制: 'Copy',
  复制报价单: 'Copy Quotation',
  基本信息: 'Basic Information',
  系统信息: 'System Information',
  报价明细: 'Quotation Details',
  添加明细: 'Add Details',
  合计: 'Total',
  含税: 'Tax Included',
  客户折后总价: 'Customer Discounted Total Price',
  数据加载中: 'Loading Data',
  编辑报价单明细: 'Edit Quotation Details',
  添加报价单明细: 'Add Quotation Details',
  数据保存中: 'Saving Data',
  操作失败: 'Operation Failed',
  是必填项: ' Is Mandatory',
  是必选项: ' Is Necessary',
  暂无此报价单查看权限: 'No Permission to View this Quotation',
  加载中: 'Loading',
  全选: 'Select All',
  详细信息: 'Detailed Information',
  审批记录: 'Approval Records',
  历史报价: 'Historical Quotation',
  报价单: 'Quotation',
  客户: 'Customer',
  商机名称: 'Opportunity Name',
  报价单金额: 'Quotation Amount',
  报价日期: 'Quotation Date',
  暂无历史报价记录: 'No Historical Quotation Records',
  选择价格: 'Choose Price',
  请选择产品名称: 'Please Select Product Name',
  获取数据失败: 'Failed to Retrieve Data'
};
